<template>
    <div class="content">
      <h1>{{ pageTitle }}</h1>
      <div class="content-body two-columns form-wrapper" v-if="mechanicalPartInfo">
        <div class="left">
          <div class="block">
            <MechanicalPartInfoForm v-if="mechanicalPartInfo && mechanicalPartInfo.id"
             :mechanical-part-info="mechanicalPartInfo"
             v-bind:formData.sync="partFormData"></MechanicalPartInfoForm>
            <span style="color: #9ea7b4;" v-if="mechanicalPartInfo">{{ $t('date') }}: {{ mechanicalPartInfo.updated_at || mechanicalPartInfo.created_at  }}</span>
          </div>

          <div class="block margin-top-20">
            <h2 style="margin-top: 0">{{ $t('part.info.part_number') }}</h2>
            <PartNumberForm v-if="showPartNumberForm" :part="mechanicalPartInfo"></PartNumberForm>
            <span class="warning" v-else>{{ $t('part.info.ensure_part_is_reviewed_and_category_set') }}</span>
          </div>

          <div class="block margin-top-20">
            <h2>{{ $t('part.spec_property_values') }}</h2>
            <PartSpecPropertiesForm v-if="hasManufacturerPartLoaded"
              ref="specsForm"
              :manufacturerPart="mechanicalPartInfo"
              :categoryId="mechanicalPartInfo.part_category_id"
              :spec-attributes="specValues"
              :loading="loadingSpecValues"
              @specs-saved="onSpecsSaved">
            </PartSpecPropertiesForm>
          </div>
        </div>
        <div class="right">
          <div class="block">
          <h2>{{ $t('mechanical.image') }}</h2>
          <Uploader v-if="mechanicalPartId" @on-success="handleFileUploaded" :defaultFileList="thumbData"
                    :model-id="mechanicalPartId" :model-type="modelType" :max-num="1" accept=".jpg, .jpeg, .png, .gif, .svg, .bmp" drag-drop></Uploader>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import MechanicalPartInfoForm from './components/mechanical-part-info-form'
import PartSpecPropertiesForm from "../components/forms/part-spec-properties-form"
import Uploader from '@/components/images/uploader'
import PartNumberForm from '@/view/part/components/forms/part-number-form'
import { uploadThumbnail } from '@/api/file'

export default {
  name: 'MechanicalPartEdit',
  components: {
    MechanicalPartInfoForm,
    Uploader,
    PartSpecPropertiesForm,
    PartNumberForm
  },
  data () {
    return {
      mechanicalPartInfo: null,
      thumbData: [],
      modelType: 'manufacturer_part',
      specValues: [],
      loadingSpecValues: true,
      partFormData: null
    }
  },
  computed: {
    mechanicalPartId: function () {
      return this.$route.params.partId
    },
    pageTitle: function () {
      document.title = this.$t('mechanical.edit.title') + ' - ' + this.mechanicalPartInfo?.name
      return document.title
    },
    showPartNumberForm: function () {
      return this.mechanicalPartInfo && this.mechanicalPartInfo.reviewed === 1 && this.mechanicalPartInfo.category
    },
    hasManufacturerPartLoaded: function () {
      return this.mechanicalPartInfo && this.mechanicalPartInfo.id
    }
  },
  mounted () {
    this.getMechanicalPartInfo(this.mechanicalPartId)
    this.loadSpecValues(this.$route.params.partId)
  },
  methods: {
    ...mapActions([
      'getMechanicalPart',
      'getMechanicalPartSpec'
    ]),
    getMechanicalPartInfo (id) {
      this.getMechanicalPart(id).then(resp => {
        this.mechanicalPartInfo = resp.data
        this.thumbData = resp.data.thumb
      })
    },
    handleFileUploaded (fileManaged) {
      uploadThumbnail(this.modelType, this.mechanicalPartId, fileManaged.id).then(resp => {
        this.$Message.success('Upload successfully!')
      })
    },
    loadSpecValues (partId) {
      this.getMechanicalPartSpec(partId).then(resp => {
        this.specValues = resp
      }).finally(() => {
        this.loadingSpecValues = false
      })
    },
    onSpecsSaved(manufacturerPart) {
      this.getMechanicalPartInfo(manufacturerPart.id)
      // this.updateForm(manufacturerPart)
    }
  },
  watch: {
    mechanicalPartId: function (newId) {
      if (newId) {
        this.getMechanicalPartInfo(newId)
      }
    }
  }
}
</script>

<style scoped>

</style>
